(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-marquee"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const marqueeSetup = function() {
    const track = document.querySelector('.marquee-track');
    if (!track) return;
    
    // Get the scroll speed from data attribute and make it faster
    const originalSpeed = parseFloat(track.getAttribute('data-speed')) || 30;
    const speed = originalSpeed / 2; // This will make it twice as fast
    
    // Get all items and calculate the total width of one set
    const items = track.querySelectorAll('.marquee-item');
    const firstHalf = Array.from(items).slice(0, items.length / 2);
    
    // Calculate exact width of first set of items
    let setWidth = 0;
    firstHalf.forEach(item => {
      setWidth += item.offsetWidth;
    });
    
    // Create the keyframes for exact width
    const keyframes = `
      @keyframes marqueeScroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-${setWidth}px); }
      }
    `;
    
    // Create and append a style element with our custom keyframes
    const style = document.createElement('style');
    style.textContent = keyframes;
    document.head.appendChild(style);
    
    // Apply the animation to the track
    track.style.animation = `marqueeScroll ${speed}s linear infinite`;
    
    // Make sure we have enough items to fill the screen
    const screenWidth = window.innerWidth;
    if (setWidth < screenWidth * 2) {
      // We need more clones to ensure continuous flow
      const itemsNeeded = Math.ceil((screenWidth * 2) / setWidth) - 1;
      for (let i = 0; i < itemsNeeded; i++) {
        firstHalf.forEach(item => {
          const clone = item.cloneNode(true);
          track.appendChild(clone);
        });
      }
    }
  };

  // Run initial setup
  marqueeSetup();
  
  // Re-run on window resize with debounce
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(marqueeSetup, 250);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom-column"] && !Shopify.designMode) return;
  try {
    
/* optional: your JS here */

  } catch(e) { console.error(e); }
})();
})();
